import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { IOException3fje1ukjwthwb as IOException } from '../../../../../okio-parent-okio/okio/NonJvmPlatform.mjs';
import { RuntimeException1r3t0zl97011n as RuntimeException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ApolloNetworkExceptionClass;
function ApolloNetworkException() {
  if (ApolloNetworkExceptionClass === VOID) {
    class $ extends ApolloException() {
      static c47(message, platformCause) {
        message = message === VOID ? null : message;
        platformCause = platformCause === VOID ? null : platformCause;
        var $this = this.n4c(message, platformCause instanceof Error ? platformCause : null);
        captureStack($this, $this.b47_1);
        $this.a47_1 = platformCause;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloNetworkException', $.c47);
    ApolloNetworkExceptionClass = $;
  }
  return ApolloNetworkExceptionClass;
}
var OfflineExceptionClass;
function OfflineException() {
  if (OfflineExceptionClass === VOID) {
    class $ extends IOException() {
      static r4c() {
        OfflineException_instance = null;
        var $this = this.b3z('The device is offline');
        OfflineException_instance = $this;
        captureStack($this, $this.q4c_1);
        return $this;
      }
      toString() {
        return 'OfflineException';
      }
      hashCode() {
        return -155984151;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OfflineException()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'OfflineException');
    OfflineExceptionClass = $;
  }
  return OfflineExceptionClass;
}
var OfflineException_instance;
function OfflineException_getInstance() {
  if (OfflineException_instance === VOID)
    OfflineException().r4c();
  return OfflineException_instance;
}
var ApolloExceptionClass;
function ApolloException() {
  if (ApolloExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static n4c(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.nd(message, cause);
        captureStack($this, $this.m4c_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloException');
    ApolloExceptionClass = $;
  }
  return ApolloExceptionClass;
}
var JsonDataExceptionClass;
function JsonDataException() {
  if (JsonDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      static w46(message) {
        var $this = this.n4c(message);
        captureStack($this, $this.v46_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonDataException');
    JsonDataExceptionClass = $;
  }
  return JsonDataExceptionClass;
}
var DefaultApolloExceptionClass;
function DefaultApolloException() {
  if (DefaultApolloExceptionClass === VOID) {
    class $ extends ApolloException() {
      static l44(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.n4c(message, cause);
        captureStack($this, $this.k44_1);
        return $this;
      }
    }
    initMetadataForClass($, 'DefaultApolloException', $.l44);
    DefaultApolloExceptionClass = $;
  }
  return DefaultApolloExceptionClass;
}
var ApolloHttpExceptionClass;
function ApolloHttpException() {
  if (ApolloHttpExceptionClass === VOID) {
    class $ extends ApolloException() {
      static z4c(statusCode, headers, body, message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.n4c(message, cause);
        captureStack($this, $this.y4c_1);
        $this.v4c_1 = statusCode;
        $this.w4c_1 = headers;
        $this.x4c_1 = body;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloHttpException');
    ApolloHttpExceptionClass = $;
  }
  return ApolloHttpExceptionClass;
}
var RouterErrorClass;
function RouterError() {
  if (RouterErrorClass === VOID) {
    class $ extends ApolloException() {
      static f4d(errors) {
        var tmp0_safe_receiver = firstOrNull(errors);
        var $this = this.n4c("Router error(s) (first: '" + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h46_1) + "')");
        captureStack($this, $this.e4d_1);
        $this.d4d_1 = errors;
        return $this;
      }
    }
    initMetadataForClass($, 'RouterError');
    RouterErrorClass = $;
  }
  return RouterErrorClass;
}
var SubscriptionOperationExceptionClass;
function SubscriptionOperationException() {
  if (SubscriptionOperationExceptionClass === VOID) {
    class $ extends ApolloException() {
      static l4d(operationName, payload) {
        var $this = this.n4c('Operation error ' + operationName);
        captureStack($this, $this.k4d_1);
        $this.j4d_1 = payload;
        return $this;
      }
    }
    initMetadataForClass($, 'SubscriptionOperationException');
    SubscriptionOperationExceptionClass = $;
  }
  return SubscriptionOperationExceptionClass;
}
var ApolloGraphQLExceptionClass;
function ApolloGraphQLException() {
  if (ApolloGraphQLExceptionClass === VOID) {
    class $ extends ApolloException() {
      static s44(error) {
        var $this = this.n4c("GraphQL error: '" + error.h46_1 + "'");
        captureStack($this, $this.r44_1);
        $this.p44_1 = error;
        $this.q44_1 = listOf($this.p44_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloGraphQLException');
    ApolloGraphQLExceptionClass = $;
  }
  return ApolloGraphQLExceptionClass;
}
var NullOrMissingFieldClass;
function NullOrMissingField() {
  if (NullOrMissingFieldClass === VOID) {
    class $ extends ApolloException() {
      static d45(message) {
        var $this = this.n4c(message);
        captureStack($this, $this.c45_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NullOrMissingField');
    NullOrMissingFieldClass = $;
  }
  return NullOrMissingFieldClass;
}
var NoDataExceptionClass;
function NoDataException() {
  if (NoDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      static y44(cause) {
        var $this = this.n4c('No data was found', cause);
        captureStack($this, $this.x44_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NoDataException');
    NoDataExceptionClass = $;
  }
  return NoDataExceptionClass;
}
var JsonEncodingExceptionClass;
function JsonEncodingException() {
  if (JsonEncodingExceptionClass === VOID) {
    class $ extends ApolloException() {
      static d4c(message) {
        var $this = this.n4c(message);
        captureStack($this, $this.c4c_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonEncodingException');
    JsonEncodingExceptionClass = $;
  }
  return JsonEncodingExceptionClass;
}
var ApolloWebSocketClosedExceptionClass;
function ApolloWebSocketClosedException() {
  if (ApolloWebSocketClosedExceptionClass === VOID) {
    class $ extends ApolloException() {
      static s4d(code, reason, cause) {
        reason = reason === VOID ? null : reason;
        cause = cause === VOID ? null : cause;
        var $this = this.n4c("WebSocket Closed code='" + code + "' reason='" + reason + "'", cause);
        captureStack($this, $this.r4d_1);
        $this.p4d_1 = code;
        $this.q4d_1 = reason;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloWebSocketClosedException');
    ApolloWebSocketClosedExceptionClass = $;
  }
  return ApolloWebSocketClosedExceptionClass;
}
//region block: exports
export {
  ApolloException as ApolloException16lek20l78zc3,
  ApolloGraphQLException as ApolloGraphQLException2qazyzs4ebcad,
  ApolloHttpException as ApolloHttpException3o30u8ntkffuh,
  ApolloNetworkException as ApolloNetworkException3denf70pfh242,
  ApolloWebSocketClosedException as ApolloWebSocketClosedException26hvn543pf46i,
  DefaultApolloException as DefaultApolloException8w3ielfxng0h,
  JsonDataException as JsonDataException2rdtm884tky1l,
  JsonEncodingException as JsonEncodingException1gbe1fu68vssf,
  NoDataException as NoDataException34qvcinicy2ih,
  NullOrMissingField as NullOrMissingField1bkks6typ2v8h,
  RouterError as RouterError3i6hxcnqsy5l3,
  SubscriptionOperationException as SubscriptionOperationException3t8cqqpx8bt9j,
  OfflineException_getInstance as OfflineException_getInstanceq1tpn78onqx1,
};
//endregion

//# sourceMappingURL=Exceptions.mjs.map
